export default __webpack_public_path__ + "static/media/package-icon.23487e8e.svg";